
import { CdFdTaskTypes } from "../CdFdTaskTypes"
import { CdFdProcessHelper } from "../CdFdProcessHelper"
import { ChFileCategories } from "src/pkScripts/Helpers/ChFileCategories"

export class CdRequestForMaterialsSharedHelper {    
    static ApprovementRoles =
    {
        GeneralDirectorID : "b33ec830-0d48-4ce6-a6dc-7413000f8691",
        GeneralDirectorName :"Генеральный директор",

        DirectorConstructionID : "8111f857-c86e-495b-a9ef-9dda2372d467",
        DirectorConstructionName :"Директор строительства",

        DirectorSMUID : "87539e21-3121-48a2-9b9f-566375e39d9b",
        DirectorSMUName :"Директор СМУ",

        SupplyDivisionLeadSpecialistID : "b59a21f4-0849-4107-b8f2-b46c04865dc7",
        SupplyDivisionLeadSpecialistName :"Ведущий специалист отдела снабжения",

        PTOEngeneerID : "5925dd24-39f4-4e26-9f1c-4bc0ad8a13df",
        PTOEngeneerName :"Инженер ПТО",

        PTOManagerID : "39d226bf-2d1f-44cf-9538-008e7e9e8a52",
        PTOManagerName :"Начальник ПТО",

        PTOManagerSKBID : "0db1f335-65f0-4d7e-bca8-a975fb20e9ae",
        PTOManagerSKBName :"Начальник ПТО по СКБ и КП УГС",

        SupplyDivisionID : "fcfa4ac8-aadc-4370-a8c2-d2b75e4ff03e",
        SupplyDivisionName :"Отдел снабжения",

        DirectorRenovationID : "6e68a42a-f72e-492d-966a-0de9cd22375a",
        DirectorRenovationName :"Заместитель генерального директора по строительству (объекты реновации)",

        DirectorCommercialID : "d2d4567c-7d4b-486c-82df-8ae034372cdd",
        DirectorCommercialName :"Заместителя генерального директора - директор по строительному производству (коммерческие объекты)",

        AdditionalApproversID : "4006f16c-32a9-409a-b135-9ffb5e758402",
        AdditionalApproversName :"Дополнительные согласующие",
    }

    static RolesFromRdDivision: Array<{guid,number}> = [
        {guid:CdRequestForMaterialsSharedHelper.ApprovementRoles.DirectorConstructionID,number:15}
        ,{guid:CdRequestForMaterialsSharedHelper.ApprovementRoles.DirectorSMUID,number:29}
        ,{guid:CdRequestForMaterialsSharedHelper.ApprovementRoles.PTOEngeneerID,number:64}
    ];    

    static CheckFileCategoryList = [ChFileCategories.RequestForMaterials.id]

    static ApproverTaskStoreInfo =
    {
        TaskStartProcessOptionsList: [CdFdProcessHelper.PkSendForSigning,CdFdProcessHelper.PkSendForResigning],    
        TaskStartProcessTypesList : [CdFdTaskTypes.PkSignRequestForMaterialsInitializingTypeID,CdFdTaskTypes.PkSignRequestForMaterialsToReworkTypeID]  ,
        TaskSignTypesList : [CdFdTaskTypes.PkSignRequestForMaterialsSigningTypeID,CdFdTaskTypes.PkSignRequestForMaterialsEngeneerPTOSigningTypeID]
    }
}

